import React from "react";

import { Line } from "react-chartjs-2";

import { colors } from "shared/ui/tokens";

import { Wrapper } from "./styles";

export interface LineChartPoint {
    label: string;
    value: number;
}

interface LineChartProps {
    points: LineChartPoint[];
    // Подпись ряда в тултипе: «Выручка, ₽».
    seriesLabel: string;
    /*
    * Значение → подпись. Деньги приходят в минорных единицах, и знать об этом должен
    * вызывающий: у примитива нет ни валюты, ни локали.
    * */
    formatValue: (value: number) => string;
    height?: number;
    className?: string;
}

const DEFAULT_HEIGHT = 340;

/*
* Линейный график. Обёртка над chart.js: конфиг и цвета живут здесь, наружу торчат только
* точки и форматтер — фичи в стороннюю библиотеку не ходят, как и в MUI.
*
* ⚠️ chart.js здесь второй версии (2.9): опции осей называются xAxes/yAxes и лежат массивами,
* в 3.x это уже scales.x/scales.y. При апгрейде библиотеки правится этот файл, а не фичи.
* */
export const LineChart = ({
    points,
    seriesLabel,
    formatValue,
    height = DEFAULT_HEIGHT,
    className,
}: LineChartProps) => {
    const data = {
        labels: points.map((point) => point.label),
        datasets: [
            {
                label: seriesLabel,
                data: points.map((point) => point.value),
                fill: false,
                backgroundColor: "transparent",
                borderColor: colors.primary,
                pointBackgroundColor: colors.primary,
                pointRadius: points.length > 60 ? 0 : 3,
                borderWidth: 2,
                lineTension: 0,
            },
        ],
    };

    const options = {
        maintainAspectRatio: false,
        legend: { display: false },
        tooltips: {
            intersect: false,
            callbacks: {
                label: (item: { yLabel: number }) => `${seriesLabel}: ${formatValue(item.yLabel)}`,
            },
        },
        hover: { intersect: false },
        scales: {
            xAxes: [
                {
                    gridLines: { display: false },
                    ticks: {
                        fontColor: colors.textSecondary,
                        maxRotation: 0,
                        autoSkipPadding: 16,
                    },
                },
            ],
            yAxes: [
                {
                    // Ноль на оси обязателен: без него скачок в пару процентов выглядит обвалом.
                    ticks: {
                        beginAtZero: true,
                        fontColor: colors.textSecondary,
                        callback: (value: number) => formatValue(value),
                    },
                    gridLines: { color: colors.borderSofter },
                },
            ],
        },
    };

    return (
        <Wrapper $height={height} className={className}>
            <Line data={data} options={options} />
        </Wrapper>
    );
};
